// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The path tracker token.
 */
export const IFileBrowserFactory = new Token('@jupyterlab/filebrowser:IFileBrowserFactory');
/**
 * The token that indicates the default file browser commands are loaded.
 */
export const IFileBrowserCommands = new Token('@jupyterlab/filebrowser:IFileBrowserCommands');
//# sourceMappingURL=tokens.js.map